import { collection, addDoc, getDocs, query, where, deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase.config";

export const AgentService = {
  // Get all saved agents for a user
  getUserAgents: async (userId) => {
    const q = query(collection(db, "savedAgents"), where("userId", "==", userId));
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  },

  // Save an agent for a user
  saveAgent: async (userId, agent) => {
    // Check if agent is already saved
    const q = query(
      collection(db, "savedAgents"), 
      where("userId", "==", userId),
      where("agentId", "==", agent.agent_id)
    );
    const snapshot = await getDocs(q);
    
    // If agent is already saved, return the existing one
    if (!snapshot.empty) {
      const existingDoc = snapshot.docs[0];
      return {
        id: existingDoc.id,
        ...existingDoc.data()
      };
    }

    // Store only the necessary agent information
    const savedAgent = {
      userId,
      agentId: agent.agent_id,
      name: agent.name,
      description: agent.description,
      icon: agent.icon || "/icons/ai-agent.svg",
      invoke_agent_input: agent.invoke_agent_input,
      savedAt: new Date()
    };
    
    const docRef = await addDoc(collection(db, "savedAgents"), savedAgent);
    return {
      id: docRef.id,
      ...savedAgent
    };
  },

  // Remove a saved agent
  removeAgent: async (savedAgentId) => {
    await deleteDoc(doc(db, "savedAgents", savedAgentId));
    return true;
  }
}; 